import React from 'react';
import * as consts from 'config/consts';

type DateButtonProps = {
  selectIndex: number;
  omitTypes: number[];
  onChangeDate: (selectIndex: number) => void;
};

const DateButton: React.FC<DateButtonProps> = props => {
  const { selectIndex, omitTypes, onChangeDate } = props;

  const buttons = Object.keys(consts.ChartPeriodTypes)
    .map((value, index) => {
      if (omitTypes.find(o => o === index) !== undefined) {
        return undefined;
      }
      const cl_active =
        selectIndex === index
          ? 'bg-blue-700 text-white rounded'
          : 'cursor-pointer';
      return (
        <div
          id={`${
            index === consts.ChartPeriodTypes.直近
              ? 'assetTransition_lastest'
              : index === consts.ChartPeriodTypes.週
              ? 'assetTransition_week'
              : index === consts.ChartPeriodTypes.月
              ? 'assetTransition_month'
              : index === consts.ChartPeriodTypes.年
              ? 'assetTransition_year'
              : ''
          }`}
          className={`w-10 ${cl_active}`}
          key={index}
          onClick={() => onChangeDate(index)}>
          {value}
        </div>
      );
    })
    .filter(value => value !== undefined);

  const viewButtons = buttons.map((value, index) => {
    return (
      <div className="flex justify-center text-center" key={index}>
        {value}
        {index < buttons.length - 1 && <div className="w-4">｜</div>}
      </div>
    );
  });

  return (
    <div className="flex justify-center text-center text-sm text-gray-500 mx-3 mt-3 mb-1">
      {viewButtons}
    </div>
  );
};
export default DateButton;
